// extracted by css-extract-rspack-plugin
export default {"sidebar":"lak6e _79NX","item":"IXXwM _Uhde PsTpS cahH4 lyZjJ","icon":"kPL16","selected":"AdZag","name":"_vrES SJXBn ygoQK"};